import { merge } from 'lodash';
import { isEnvDevelopment } from 'constants/index';

// Determine which config file to load based on environment
const env = process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV || 'production';
let envConfig;
switch (env) {
    case 'production':
        envConfig = require('./config.production.js').default;
        break;
    case 'stage':
        envConfig = require('./config.stage.js').default;
        break;
    case 'test':
        envConfig = require('./config.test.js').default;
        break;
    case 'development':
    default:
        envConfig = require('./config.development.js').default;
        break;
}

const defaults = {
    appName: process.env.REACT_APP_NAME,
    devTools: isEnvDevelopment,
    sentry: {
        dsn: 'https://70c23dfe6523430e838c755a10cb478c@o367752.ingest.sentry.io/5715799',
    },
    airtime: {
        url: 'https://airtimeux.com/airtime.js',
        token: 'mdbdxi3h9qishn33',
    },
    api: {
        signIn: '/v1/auth/sign-in',
        forgotPassword: '/v1/auth/forgot-password',
        me: '/v1/users/me',
        refresh: '/v1/auth/refresh',
        elevators: '/v1/elevators',
        maintenances: '/v1/maintenances',
        activeIncidents: '/v1/active-incidents',
        elevator: '/v1/elevators/:id',
        averageTrips: '/v1/elevators/:id/average-trips',
        elevatorState: '/v1/elevators/:id/state',
        totalTrips: '/v1/elevators/:id/total-trips',
        elevatorStates: '/v1/elevators/:id/states',
        floorActivity: '/v1/elevators/:id/floor-activity',
        documentInvoices: '/v1/customer-documents/invoices',
        documentContracts: '/v1/customer-documents/contracts',
        documentQuotations: '/v1/customer-documents/quotations',
        documentAssessmentReports: '/v1/customer-documents/elevator-assessments',
        downloadDocuments: '/v1/customer-documents/download',
        otherDocuments: '/v1/customer-documents/others',
        workorderDocuments: '/v1/workorder-documents',
        uploadDocuments: '/v1/:service/upload/:type',
        onboardingUpload: '/v1/onboarding/upload',
        salesforceRegister: '/v1/users/salesforce-register',
        subscribeFake: '/v1/emails/fake-door-page-info',
        activeIncident: '/v1/active-incident/:id',
        iotConfig: '/v1/config',
        incidents: '/v1/incidents',
        updateIncident: '/v1/incidents/:caseNumber',
        closedIncidents: '/v1/closed-incidents/:id',
        supportRequest: '/v1/supports',
        support: '/v1/support-requests',
        users: '/v1/users',
        workorders: '/v1/work-orders',
        documentProcessing: '/v1/document-processing',
        documentProcessingDetail: '/v1/document-processing/:id',
        documentProcessingSubmit: '/v1/document-processing/:id/submit',
        search: '/v1/search',
        reporting: '/v1/document-scanner-logs/errors',
        reportingLogs: '/v1/document-scanner-logs',
        askAuto: '/v1/ask/auto',
        portalDocuments: '/v1/landing-page-documents',
        quickAnalysisUpload: '/v1/landing-page-documents/upload/invoice',
        quickAnalysisAssessmentReportUpload: '/v1/landing-page-documents/upload/assessment-report',
        landingPageDocumentErrors: '/v1/landing-page-documents/errors',
        landingPageAssessmentReportsSubmit: '/v1/landing-page-assessment-reports/submit',
        landingPageAssessmentReports: '/v1/landing-page-assessment-reports',
        magicLinkRequest: '/v1/customer-portal/auth/magic-link',
        magicLinkVerify: '/v1/customer-portal/auth/verify',
        guestDocuments: '/v1/customer-portal/documents',
        guestAssessmentReportReplies: '/v1/customer-portal/assessment-reports',
        salesforceMagicLoginRequest: '/v1/auth/salesforce-magic-login',
        salesforceMagicLoginVerify: '/v1/auth/salesforce-magic-login/verify',
    },
    routes: {
        home: '/',
        login: '/login',
        magicLogin: '/magic-login',
        registration: '/registration',
        createPassword: '/create-password',
        forgotPassword: '/forgot-password/:step',
        elevators: '/elevators',
        elevatorDetail: '/elevators/:id',
        elevatorHistory: '/elevators/:id/history',
        documents: '/documents',
        supportRequest: '/support-request',
        support: '/support',
        documentsUpload: '/documents/upload',
        invoices: '/documents/invoices',
        contracts: '/documents/contracts',
        riskAssessments: '/documents/risk-assessment-reports',
        emergencyPlans: '/documents/emergency-rescue-plans',
        supportOpen: '/supports/open',
        supportClosed: '/supports/closed',
        conditionReports: '/documents/condition-reports',
        quotations: '/documents/quotations',
        assessmentReports: '/documents/assessment-reports',
        otherDocuments: '/documents/other',
        notfallplan: '/documents/notfallplan',
        flap: '/documents/flap',
        sticker: '/documents/sticker',
        uploadContract: '/upload-contract',
        uploadQuotation: '/upload-quotation',
        uploadZUES: '/upload-zues',
        uploadZUESDeficiency: '/upload-zues-deficiency',
        operatorObligations: '/operator-obligations',
        maintenanceAnalysis: '/maintenance-analysis',
        incidents: '/incidents',
        incident: '/incident/:id',
        incidentsActive: '/incidents/active',
        incidentsResolved: '/incidents/resolved',
        browserIssues: '/browser-issues',
        workOrders: '/work-orders',
        teams: '/teams',
        documentProcessing: '/document-processing',
        reporting: '/reporting',
        assistant: '/data-assistant',
        guestLogin: '/guest-login',
        guestVerify: '/auth',
        guestDocuments: '/guest/documents',
    },
    aws: {
        amplify: {
            Auth: {
                mandatorySignIn: true,
            },
        },
    },
    analytics: {
        trackingId: 'G-GMM2DLGZKZ',
    },
    quickAnalysisApiKey:
        'hyKGPAMBNeE6WggZ1kMLsl1qbWhVOAVP1JGpHcANHi1jB12sPciqpWRK5gHTE4FLBXgAz6kRRxjGYtpsDoQ2ubrLansEODcs9FjGWuMFCM0WpFxDMN3Lx4yYi5q4FePJ',
    tables: {
        defaultPageSize: 10,
    },
    currency: 'EUR',
};

export default merge(defaults, envConfig);
